import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { prettyTopScorersUrl } from '../../../common/rcs_gaz_mc_core_FE';
import DynamicTable from '../../../components/DynamicTable';
import Label from '../../../components/shared/Label';
import StandingButton from '../../../components/shared/StandingButton';
import * as types from '../../../constants';
import { TopScorersWidgetWrapper } from './styles';

class TopScorersWidgetGazzanet extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    const {
      competitionId, sportId, actions, widgetId,
    } = this.props;
    actions.getTopScorers(sportId, competitionId, widgetId);
    this.resizeCallback();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  getGazzanetDomain = (url) => {
    let returnedDomain = 'gazzetta';
    if (url && url.hostname) {
      const site = url.hostname;
      const [, domain] = site.split('.');
      returnedDomain = domain;
    }
    return returnedDomain;
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  isGazzanet = () => {
    let disableLink = false;
    if (process.env.REACT_APP_SITE === 'gazzanet') {
      disableLink = true;
    }
    return disableLink;
  };

  render() {
    const {
      actions, dictionary, standings, competitionId, sportId, widgetId,
    } = this.props;
    const {
      isMobile,
    } = this.state;
    const standing = standings[widgetId];
    return (
      <TopScorersWidgetWrapper isGazzanet={this.isGazzanet()}>
        <Label
          //label="Classifica Marcatori"
          size={1.3}
          weight="bold"
          margin="10px 0 16px"
          label={`Marcatori ${dictionary.competitionTable.competitionName[competitionId]}`}
        />
        <DynamicTable
          actions={actions}
          data={standing}
          dictionary={dictionary.widgets.cols}
          tableRowsKey="competitionMarkers"
          isMobile={isMobile}
          competitionId={competitionId}
          isTopScorer
          hasTitle
          isGazzanet
        />
      </TopScorersWidgetWrapper>
    );
  }
}

TopScorersWidgetGazzanet.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  standings: PropTypes.any,
  competitionId: PropTypes.any,
  sportId: PropTypes.any,
  widgetId: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    standings: state.topScorersReducer.topScorers,
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getTopScorers: (sportId, competitionId, widgetId) =>
        dispatch({
          type: types.GET_TOP_SCORERS_REQUEST,
          sportId,
          competitionId,
          widgetId,
        }),
    },
  }),
)(TopScorersWidgetGazzanet);



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/TopScorersWidgetGazzanet/index.js